var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOsLinux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "16px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linux-svgrepo-com 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.4058492%",
    y1: "23.0292099%",
    x2: "49.2475085%",
    y2: "73.1363432%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "30.6131232%",
    y1: "92.0569159%",
    x2: "22.1623738%",
    y2: "56.3196777%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-31.5932771%",
    y1: "625.447929%",
    x2: "-115.700981%",
    y2: "379.156892%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEED7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBFC2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.985%",
    y1: "16.9302171%",
    x2: "42.655%",
    y2: "80.3079949%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "48.2999932%",
    y1: "23.5406533%",
    x2: "58.3399932%",
    y2: "74.8204719%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.840432%",
    y1: "26.1002137%",
    x2: "50.128517%",
    y2: "79.0364712%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9284371%",
    y1: "42.5673857%",
    x2: "50.4448124%",
    y2: "75.0947249%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.8768199%",
    y1: "2.29973537%",
    x2: "49.8768199%",
    y2: "81.2039086%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9814874%",
    y1: "2.27086726%",
    x2: "49.971376%",
    y2: "71.7993164%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "53.4681867%",
    y1: "48.9941867%",
    x2: "38.5760776%",
    y2: "94.7480734%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.688414%",
    y1: "34.0246191%",
    x2: "69.37128%",
    y2: "84.5829946%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "54.2388058%",
    y1: "-17.2165954%",
    x2: "42.1982321%",
    y2: "63.9691458%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.8346792%",
    y1: "1.56467766%",
    x2: "51.8087432%",
    y2: "104.294834%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.54958%",
    y1: "12.5574361%",
    x2: "55.890233%",
    y2: "85.422449%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.7333714%",
    y1: "36.1150171%",
    x2: "50.1225643%",
    y2: "71.1728715%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA63F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.1703252%",
    y1: "31.2493883%",
    x2: "49.9539859%",
    y2: "67.5792481%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.65,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Websites",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linux-svgrepo-com-2",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linux-svgrepo-com"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24504,12.5028571 C3.1448,12.3605333 3.05712,12.1686095 2.98592,11.9389714 C1.700568,10.5584762 2.69352,8.52693333 3.67568,7.14742857 C3.76984,6.99992381 3.8724,6.85744762 3.98392,6.72114286 C4.73328,5.8344381 4.92712,5.21737143 4.9848,4.38255238 C4.99168,4.22712381 4.97816,4.02140952 4.96264,3.78499048 C4.88336,2.57805714 4.7516,0.572754286 7.01272,0.394971429 C9.83912,0.17271619 9.60888,2.64460952 9.588,4.09386667 C9.58712,4.15382857 9.58624,4.21219048 9.58568,4.26849524 C9.578,5.14209524 10.05672,5.74026667 10.5564,6.36457143 C10.73888,6.59260952 10.92416,6.82407619 11.0896,7.07375238 C11.09448,7.08114286 11.09936,7.08860952 11.10424,7.096 C11.97744,8.29539048 12.83952,10.0853333 11.6396,11.7830857 C11.47096,12.3625905 11.2156,12.8944762 10.87472,13.3273143 C9.65088,14.8611048 8.56312,14.7053714 7.7136,14.5837714 C7.45736,14.5471238 7.2228,14.5135238 7.01272,14.5303619 C6.66376,14.5506286 6.38408,14.6043429 6.14248,14.650819 C5.20864,14.8303238 4.84368,14.9004952 3.24504,12.5028571 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.61112,1.74820571 C8.58488,2.4585981 7.79368,3.07566476 6.8452,3.13270095 C5.89672,3.18974476 5.15256,2.65046095 5.1788,1.94006095 C5.20496,1.22966095 5.99624,0.612601905 6.94472,0.555558095 C7.8932,0.503710476 8.63728,1.03780571 8.61112,1.74820571 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89248,3.47497143 C6.90008,3.86125714 7.08584,4.19062857 7.34672,4.33942857 C6.4956,4.26681905 5.44096,4.56312381 5.44096,5.1239619 C5.42784,6.07260952 4.87344,7.25295238 4.47432,8.10255238 C4.39576,8.26994286 4.3232,8.42445714 4.26192,8.56182857 C4.01488,9.14445714 3.86664,9.76761905 3.84912,10.3787429 C3.1948,9.51977143 3.67024,8.41782857 3.92656,7.93958095 C4.26768,7.31024762 4.26112,7.23169524 4.12864,7.3792 C3.62072,8.20175238 2.66424,9.85394286 3.862,10.8464762 C3.9,11.2896762 4.01336,11.7190857 4.2148,12.1138286 C5.81824,15.193981 8.82088,13.9287619 9.81128,12.3316571 C9.94304,12.1045333 10.0496,11.8848762 10.13416,11.6726095 C10.18376,11.7023238 10.23688,11.7253333 10.29336,11.7404952 C10.7912,11.8805333 11.53528,11.3464381 11.71344,11.0145524 C11.92832,10.5737905 11.70824,10.2729905 10.97464,9.9152 C10.9372,9.8976 10.90024,9.88099048 10.86376,9.86552381 C11.14512,8.73721905 10.36976,7.56388571 9.816,7.06613333 C9.71272,7.04182857 9.69816,7.0976 9.85848,7.24990476 C10.2072,7.56822857 10.96576,8.70308571 10.55536,9.75931429 C10.48776,9.74201905 10.42272,9.72982857 10.36072,9.72312381 C10.23464,9.00251429 9.89848,8.44190476 9.66352,8.05013333 C9.61032,7.96137143 9.56232,7.88129524 9.52304,7.80998095 C9.444,7.66605714 9.34944,7.51702857 9.24912,7.35900952 C8.86264,6.75001905 8.3912,6.00708571 8.3912,4.90613333 C8.33208,4.66392381 8.09208,4.5024 7.77264,4.41318095 C8.14344,4.34194286 8.42176,3.92937143 8.41216,3.43352381 C8.40168,2.89939048 8.05056,2.47418667 7.63136,2.48456381 C7.21216,2.49493333 6.8768,2.94087619 6.89248,3.47497143 Z M7.23832,3.59420952 C7.23312,3.88982857 7.37984,4.12830476 7.57376,4.12830476 C7.7624,4.12830476 7.9248,3.88982857 7.93008,3.59939048 C7.93528,3.30385524 7.78856,3.06532571 7.59472,3.06532571 C7.4008,3.06532571 7.2436,3.30385524 7.23832,3.59420952 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00836982,4.30460952 C6.39537725,4.28906667 6.67562401,3.90019048 6.64231224,3.43870476 C6.60889859,2.97717333 6.26864989,2.61938286 5.88154059,2.63493333 C5.49453316,2.65049143 5.2142864,3.0393981 5.24770004,3.50087619 C5.28101182,3.9623619 5.62136239,4.32015238 6.00836982,4.30460952 Z M6.24185785,3.59939048 C6.2752715,3.84312381 6.15516574,4.05051429 5.98167965,4.07131429 C5.80819356,4.08685714 5.64132908,3.90537143 5.60801731,3.6616381 C5.57460366,3.41793524 5.69470941,3.21051429 5.8681955,3.18977524 C6.04168159,3.17421714 6.20854608,3.35570286 6.24185785,3.59939048 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31688,3.42828952 C7.30112,3.59420952 7.37976,3.72906667 7.48976,3.73942857 C7.59984,3.74979048 7.70464,3.62011429 7.72032,3.45942857 C7.73608,3.29346286 7.65744,3.15864381 7.54744,3.14827429 C7.43736,3.13790476 7.33256,3.26754286 7.31688,3.42828952 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.9128,3.46986667 C5.92848,3.60472381 5.87088,3.7239619 5.78704,3.73432381 C5.7032,3.74468571 5.62456,3.64099048 5.6088,3.50102857 C5.59312,3.36617905 5.65072,3.2469181 5.73464,3.23654857 C5.81848,3.22617905 5.89704,3.33507048 5.9128,3.46986667 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.1352,8.87809524 C9.1352,9.79070476 8.2496,10.9730286 6.73,10.9626667 C5.16312,10.9730286 4.49768,9.79070476 4.49768,8.87809524 C4.49768,7.96548571 5.5352,7.22392381 6.81384,7.22392381 C8.09768,7.22918095 9.1352,7.96548571 9.1352,8.87809524 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30768,6.01081905 C8.292,6.95459048 7.6684,7.17752381 6.88232,7.17752381 C6.09632,7.17752381 5.52512,7.03748571 5.45704,6.01081905 C5.45704,5.36784762 6.09632,4.9944381 6.88232,4.9944381 C7.6684,4.98925714 8.30768,5.36266667 8.30768,6.01081905 Z",
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.55488,7.46262857 C4.06848,6.69005714 5.15312,5.50255238 3.75928,7.62857143 C2.62736,9.38125714 3.34008,10.5065143 3.70688,10.8176 C4.76536,11.7510095 4.72344,12.3784381 3.89024,11.8857905 C2.103376,10.8331429 2.47544,9.05973333 3.55488,7.46262857 Z",
    id: "Path",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.99048,7.77904762 C10.54512,6.87161905 9.13024,4.56929524 11.05864,7.24495238 C12.81408,9.66651429 11.58264,11.3517714 11.36256,11.5177143 C11.14248,11.6836571 10.4036,12.0206476 10.61848,11.4347429 C10.83856,10.8487619 11.92848,9.73912381 10.99048,7.77904762 Z",
    id: "Path",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.16712,14.9349333 C1.99332,14.3178667 0.290264,15.0541714 0.9086,13.3844571 C1.034368,13.0059429 0.725192,12.435581 0.92432,12.0673524 C1.160128,11.6162286 1.668424,11.7147429 1.972352,11.414019 C2.27104,11.1029333 2.45968,10.5636571 3.0204,10.6465524 C3.57584,10.7295238 3.94792,11.4036571 4.33568,12.2332952 C4.62392,12.8244571 5.64048,13.6592762 5.57232,14.3230476 C5.48848,15.3393524 4.31992,15.5312 3.16712,14.9349333 Z",
    id: "Path",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.101312,11.5355429 C1.815872,11.8329143 1.291616,11.7616 1.081216,12.1506286 C0.946088,12.4004571 1.093728,12.7844571 1.113648,13.0580571 C1.138256,13.3961143 0.844024,13.8750476 0.993864,14.1637333 C1.162144,14.4879238 1.922368,14.4458667 2.25656,14.492419 C3.08152,14.6071619 4.44504,15.624 5.19104,14.8124952 C5.92032,14.0192 4.51856,13.0152381 4.17472,12.310019 C3.95112612,11.8315429 3.61648,10.9142857 2.9936,10.8211048 C2.55448,10.7561905 2.35448,11.2718476 2.101312,11.5355429 Z M3.04664,10.4720762 C3.82224,10.5879619 4.21032,11.5455238 4.49656,12.1578667 C4.93104,13.0458667 6.41976,14.000381 5.45488,15.049981 C4.57856,16.0032762 3.19504,14.9793524 2.20688,14.8419048 C1.713328,14.773181 0.934864,14.8225524 0.676608,14.3249524 C0.454568,13.897219 0.78896,13.5097905 0.75792,13.0834286 C0.731472,12.7201524 0.58052,12.3300571 0.76616,11.985219 C1.020296,11.5005714 1.510912,11.6179048 1.844368,11.290819 C2.198472,10.9202286 2.41072,10.377981 3.04664,10.4720762 Z",
    id: "Shape",
    fill: "#E68C3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.30512,14.6497524 C12.16448,13.6179048 14.07712,13.8304762 12.78808,12.4148571 C12.5156,12.1089524 12.59944,11.4555429 12.26408,11.1755429 C11.87104,10.8332952 11.43608,11.1132952 11.03784,10.9369905 C10.6396,10.7451429 10.2204,10.3769905 9.73304,10.6362667 C9.24568,10.9007238 9.19328,11.585219 9.14616,12.4874667 C9.10424,13.135619 8.50688,14.2193524 8.82648,14.8156952 C9.28768,15.7386667 10.48768,15.6142476 11.30512,14.6497524 Z",
    id: "Path",
    fill: "url(#linearGradient-11)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.64776,10.8176762 C11.86808,10.8121143 12.132,10.826819 12.37984,11.0419048 C12.68808,11.3007238 12.69112,11.7232 12.80736,12.0769524 C12.94496,12.4958476 13.42728,12.7351619 13.3984,13.2264381 C13.35128,14.0294095 11.89104,14.2228571 11.4416,14.7625905 C11.00968,15.2721524 10.46376,15.5755429 9.94568,15.6164571 C9.16,15.6784762 8.51104,15.0492952 8.55696,14.2810667 C8.59424,13.6591238 8.92688,13.0941714 8.96744,12.4772571 C8.9908,12.0304762 9.016,11.6163048 9.1008,11.28 C9.18648,10.9401143 9.34088,10.6474667 9.64664,10.4815238 C10.31624,10.1252571 10.96312,10.8347429 11.64776,10.8176762 Z M9.81752,10.7913905 C9.63624,10.889981 9.52096,11.0716952 9.44688,11.3654095 C9.37192,11.6627048 9.34728,12.0436571 9.32344,12.4987429 C9.28344,13.1171048 8.95016,13.6816762 8.91304,14.3019429 C8.87992,14.8550095 9.326,15.3113143 9.91736,15.2646095 C10.31872,15.2329143 10.78176,14.9915429 11.16728,14.5369143 C11.51176,14.1236571 13.01096,13.7398857 13.04232,13.2059429 C13.0628,12.8572952 12.5812,12.5302095 12.46808,12.1861333 C12.3796,11.9168 12.37496,11.499581 12.1484,11.3104 C12.0036,11.184381 11.85128,11.1656381 11.65672,11.1705143 C11.09296,11.1845333 10.34088,10.5136762 9.81752,10.7913905 Z",
    id: "Shape",
    fill: "#E68C3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.93248,13.2704 C12.26344,11.3258667 11.27304,11.3414095 10.93768,11.1910095 C10.60232,11.0355048 10.25128,10.7295238 9.85824,10.9421714 C9.4652,11.1599238 9.44424,11.7199238 9.43376,12.4563048 C9.41808,12.985219 8.97264,13.8719238 9.23992,14.3644952 C9.5648,14.9401143 10.3508,14.105219 10.93248,13.2704 Z",
    id: "Path",
    fill: "url(#linearGradient-12)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.89456,13.5502476 C0.903272,12.2746667 1.836016,11.8390857 2.134712,11.6368 C2.49632,11.3775238 2.50152,10.8797714 2.94696,10.9264 C3.39232,10.9731048 3.65432,11.5175619 3.95304,12.1916952 C4.17312,12.6739048 4.93824,13.3168762 4.88056,13.8716952 C4.8072,14.5251048 3.75392,14.0947048 2.89456,13.5502476 Z",
    id: "Path",
    fill: "url(#linearGradient-13)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.59848,10.9990095 C11.44128,11.2686476 10.802,11.6937905 10.37752,11.5797333 C9.94264,11.4708571 9.74352,10.8641524 9.83256,10.4078476 C9.9112,9.88929524 10.37752,9.86339048 10.96448,10.1226667 C11.588,10.4026667 11.78192,10.641219 11.59848,10.9990095 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.16864,10.8486857 C11.06904,11.0353524 10.64984,11.3308952 10.3564,11.2531048 C10.06296,11.1753143 9.91624,10.7553524 9.96336,10.4390095 C10.00528,10.081219 10.31968,10.0604952 10.718,10.2368 C11.14768,10.4338286 11.28392,10.5997714 11.16864,10.8486857 Z",
    id: "Path",
    fill: "url(#linearGradient-14)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.74992,4.08198095 C5.95952,3.89005714 6.46784,3.30413714 7.432,3.9160381 C7.61016,4.03009524 7.75688,4.04045714 8.09752,4.18567619 C8.784,4.46567619 8.45904,5.13973333 7.72544,5.36792381 C7.41104,5.4664381 7.12808,5.84495238 6.56216,5.80868571 C6.0748,5.78278095 5.94904,5.4664381 5.65032,5.29531429 C5.12112,4.99977143 5.04248,4.60045714 5.33072,4.38788571 C5.61888,4.17531429 5.72896,4.09752381 5.74992,4.08198095 Z",
    id: "Path",
    fill: "url(#linearGradient-15)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39464,4.47260952 C5.28504,4.55344762 5.25016,4.66087619 5.2864,4.77973333 C5.3608,5.02384762 5.89728,5.35961905 6.10272,5.52388571 C6.21952,5.61729524 6.35312,5.69135238 6.56904,5.70285714 C7.03144,5.73249524 7.28824,5.39367619 7.69336,5.26674286 C7.95976,5.18384762 8.52352,4.8672 8.3368,4.50430476 C8.17744,4.19459048 7.64064,4.17546667 7.374,4.0048 C6.91512,3.71367619 6.58104,3.71573333 6.34304,3.79740952 C6.08224,3.88693333 5.6308,4.2983619 5.39464,4.47260952 Z M6.27288,3.59733333 C6.58248,3.49112381 6.98496,3.5063619 7.49008,3.82689524 C7.82208,4.03946667 8.3272,4.01897143 8.52744,4.40822857 C8.78256,4.904 8.1644,5.34217143 7.7576,5.46872381 C7.322,5.60533333 7.07864,5.94750476 6.55576,5.91420952 C6.28464,5.89965714 6.11072,5.80251429 5.96824,5.68860952 C5.67264,5.45226667 5.1732,5.22765714 5.05904,4.85287619 C4.99568,4.64502857 5.08808,4.43459048 5.26672,4.30278095 C5.55544,4.08982857 5.9456,3.70971429 6.27288,3.59733333 Z",
    id: "Shape",
    fill: "#E68C3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1796,4.62255238 C8.18176,4.66148571 8.1516,4.69478095 8.11232,4.6968381 C7.55768,4.72678095 7.16792,5.3296 6.5416,5.3296 C6.19112,5.3296 5.91368,5.16853333 5.71528,5.0136381 C5.67536,4.98247619 5.32264,4.72350476 5.32264,4.65752381 C5.32264,4.61851429 5.35456,4.58689524 5.394,4.58689524 C5.46768,4.58689524 5.69,4.81668571 5.77272,4.88129524 C5.9596,5.0272 6.23704,5.18841905 6.5416,5.18841905 C7.16168,5.18841905 7.54208,4.58628571 8.10448,4.55588571 C8.14384,4.55375238 8.17744,4.58361905 8.1796,4.62255238 Z",
    id: "Path",
    fill: "#E68C3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07536,4.02994286 C6.18016,3.93660952 6.51024,3.68251429 6.9452,3.94179048 C7.03952,3.9936 7.13384,4.05066667 7.27008,4.12845714 C7.54784,4.28921905 7.4116,4.52251429 7.07616,4.66773333 C6.92424,4.72998095 6.67272,4.8647619 6.48408,4.8544 C6.27448,4.83367619 6.13296,4.69881905 5.99672,4.61066667 C5.73992,4.4448 5.75568,4.3047619 5.87616,4.19588571 C5.96528,4.11291429 6.06488,4.03512381 6.07536,4.02994286 Z",
    id: "Path",
    fill: "url(#linearGradient-16)",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsLinux);
export default __webpack_public_path__ + "static/media/os_linux.fdbfd34a448c340e81a238fbbef5351e.svg";
export { ForwardRef as ReactComponent };